<template>
  <div class="data_pl">
    <div class="banner">
      <!-- <img src="../assets/sul.png" alt=""> -->
        <h1>企业和工业级AI应用服务商</h1>
        <!-- <p>介绍</p> -->
         <div class="inner_btn">
            <button @click="goToContact(2)" class="inner-le">生态合作</button>
            <button @click="goToContact(3)" class="inner-ri">联系我们</button>
         </div>
    </div>
    <div class="data_pl_video" :class="isMobile?'data_pl_video_m':''">

      <video v-if="isEnglish" style="width: 100%;height: 100%;object-fit:" src="https://official-web-static.womucloud.com/product_intro_en.mp4" controls muted autoplay loop></video>
      <video v-else style="width: 100%;height: 100%;object-fit:" src="https://official-web-static.womucloud.com/product_intro_zh.mp4" controls muted autoplay loop></video>
    </div>
    <div class="data_h">
      <h1>软件产品</h1>
    </div>
    <div class="data_main" v-if="isMobile" v-for="(item,index) in pro_data" :key="item.id">
      <div class="box" v-if="index%2===0">
        <div class="item1">
          <img :src="item.thumbnail" alt="">
        </div>
        <div class="item2" style="background-color: #BCC5CC ;" @click="goto_system(item.id)">
          <h3>{{ item.name }}</h3>
          <p>{{ item.description }}</p>
          <el-button>查看更多</el-button>
        </div>
    </div>
    <div class="box" v-if="index%2!==0">
      <div class="item2" style="background-color: #005BAB ;" @click="goto_system(item.id)">
        <h3>{{ item.name }}</h3>
        <p>{{ item.description }}</p>
        <el-button>查看更多</el-button>
      </div>
      <div class="item1">
        <img :src="item.thumbnail" alt="">
      </div>
    </div>
    </div>
    <div class="data_main" v-else v-for="(item,index) in pro_data" :key="index">
      <div class="box" v-if="index%2===0">
        <div class="item1">
          <img :src="item.thumbnail" alt="">
        </div>
        <div class="item2" style="background-color: #BCC5CC ;">
          <h3>{{ item.name }}</h3>
          <p>{{ item.description }}</p>
          <el-button @click="goto_system(item.id)">查看更多</el-button>
        </div>
    </div>
    <div class="box" v-if="index%2!==0">
      <div class="item2" style="background-color: #005BAB ;">
        <h3>{{ item.name }}</h3>
        <p>{{ item.description }}</p>
        <el-button @click="goto_system(item.id)">查看更多</el-button>
      </div>
      <div class="item1">
        <img :src="item.thumbnail" alt="">
      </div>
    </div>
    </div>
    <div class="data_split" v-if="!isMobile">
      <!-- <div class="split_main" v-if="isMobile">
        <ul>
          <li>
            <img src="../assets/pro1.png" alt="">
            <span style="color: #0173FF;">Gather</span>
          </li>
          <li>
            <img src="../assets/pro2.png" alt="">
          </li>
          <li>
            <img src="../assets/pro3.png" alt="">
            <span style="color: #00BCFF;">Analyse</span>
          </li>
          <li>
            <img src="../assets/pro4.png" alt="">
          </li>
          <li>
            <img src="../assets/pro5.png" alt="">
            <span style="color: #00CFB0;">Manage</span>
          </li>
        </ul>
        <ul>
          <li>
            <img src="../assets/pro6.png" alt="">
          </li>
          <li>
            <img src="../assets/pro7.png" alt="">
            <span style="color:#7E96FF;">Decision</span>
          </li>
          <li>
            <img src="../assets/pro8.png" alt="">
          </li>
          <li>
            <img src="../assets/pro9.png" alt="">
            <span style="color:#0173FF;">Energy conservation</span>
          </li>
        </ul>
      </div> -->
      <div class="split_main">
        <ul>
          <li>
            <img src="../assets/pro1.png" alt="">
            <span style="color: #0173FF;">采集</span>
          </li>
          <li>
            <img src="../assets/pro2.png" alt="">
          </li>
          <li>
            <img src="../assets/pro3.png" alt="">
            <span style="color: #00BCFF;">分析</span>
          </li>
          <li>
            <img src="../assets/pro4.png" alt="">
          </li>
          <li>
            <img src="../assets/pro5.png" alt="">
            <span style="color: #00CFB0;">管理</span>
          </li>
          <li>
            <img src="../assets/pro6.png" alt="">
          </li>
          <li>
            <img src="../assets/pro7.png" alt="">
            <span style="color:#7E96FF;">决策</span>
          </li>
          <li>
            <img src="../assets/pro8.png" alt="">
          </li>
          <li>
            <img src="../assets/pro9.png" alt="">
            <span style="color:#0173FF;">节能</span>
          </li>
        </ul>
      </div>
    </div>
    <div v-if="isMobile" class="pro_dis">
      <h1>解决方案</h1>
      <el-row :gutter="20">
        <el-col :span="24" v-for="item in sul_data" :key="item.id" class="uniform-height">
          <div class="image-container" :style="{ backgroundImage: `url(${item.thumbnail})` }">
            <!-- <img :src="item.thumbnail" alt="" class="full-size-image"> -->
              <div class="col-box" @click="goto_methods(item.id)">
                <h3>{{ item.name }}</h3>
                <p>{{ item.description }}</p>
              </div>
          </div>
        </el-col>
      </el-row>
    </div>
    <div v-else class="pro_dis">
      <h1>解决方案</h1>
      <el-row :gutter="20">
        <el-col :span="6" v-for="item in sul_data" :key="item.id" class="uniform-height">
          <div class="image-container" @mouseenter="toggleHover(item.id, true)" @mouseleave="toggleHover(item.id, false)" :style="{ backgroundImage: `url(${item.thumbnail})` }">
            <!-- <img :src="item.thumbnail" alt="" class="full-size-image"> -->
            <transition name="fade">
              <div v-if="hoveredIds[item.id]" class="col-boxx" @click="goto_methods(item.id)">
                <h3>{{ item.name }}</h3>
                <p>{{ item.description }}</p>
              </div>
              <div v-else class="col-box">
                <h3>{{ item.name }}</h3>
                <p>{{ item.description }}</p>
              </div>
            </transition>
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script setup>
import { onMounted,ref,onUnmounted,computed } from 'vue';
import { getProductList } from '../api/product';
import { getSolutionList } from '../api/solution';
import { useRouter } from 'vue-router';
const router = useRouter();
const pro_data = ref([]);
const sul_data = ref([]);
const isShow = ref(false);
const hoveredIds = ref({});

const toggleHover = (id, isHovered) => {
  hoveredIds.value[id] = isHovered;
};
onMounted(() => {
  window.scrollTo(0, 0);
  checkMobile()
  window.addEventListener('resize', checkMobile)
  productrender();
})
onUnmounted(() => {
  window.removeEventListener('resize', checkMobile)
})
//页面缩小，适应布局
const isEnglish = computed(() => {
  return window.location.pathname.startsWith('/en')
})
const isMobile = ref(false)
const checkMobile = () => {
  isMobile.value = window.innerWidth <= 1024
}
const emit = defineEmits(['scroll-to-contact'])
function goToContact(type) {
  emit('scroll-to-contact', type)
}
function goto_system(id) {
  router.push(`/productdetail?id=${id}`)
}
function goto_methods(id) {
  router.push(`/solutiondetail?id=${id}`)
}
async function productrender() {
  const appId = window.location.pathname.startsWith('/en') ? 2 : 1;
  const pro_res = await getProductList({ appId, current: 1, size: 100 });
  pro_data.value = pro_res.data;
  const sul_res = await getSolutionList({ appId, current: 1, size: 100 });
  sul_data.value = sul_res.data;
}
</script>

<style scoped>
.data_h h1{
  width: 60%;
  font-size: 3em;
  margin: 0 auto;
  margin-top: 1em;
  margin-bottom: 1em;
}
.data_pl {
  width: 100%;
}
.banner{
  overflow: hidden;
  width: 100%;
  height: 11em;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 0.8em;
  color:white;
  background-color: #ddd;
  margin-bottom: 4em;
  background-image: url('https://official-web-static.womucloud.com/bigBanner/pc/product.jpg');
  background-size: cover;
  background-position: center;
  text-align: center;
  background-repeat: no-repeat;
}
.inner-le,.inner-ri{
  width: 10em;
  height: 3em;
  border-radius: 1.5em;
  font-size: 1em;
  border:transparent;
  cursor: pointer;
  margin: 0.5em auto;
}
.inner_btn{
  font-size: 1em;
}
.inner-le{
  background-color: orange;
  color: white;
  margin-right: 1em;
}
.inner-ri{
  background-color: skyblue;
  color: white;
}
.banner h1{
  width: 65%;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
  overflow: hidden;
  margin: 0 auto;
  color: white;
}
.data_main{
  position: relative;
  width: 60%;
  margin: 0 auto;
}
.box{
  display: flex;
  width: 100%;
  height:300px;
  margin-bottom: 10px;
}
.box .item1{
  color:white;
  width: 30%;
  height: 100%;
  background-color: #ddd;
}
.box .item1 img{
  width: 100%;
  height: 100%;
}
.box .item2{
  color:white;
  width: 70%;
  height: 100%;
}
.box .item2 h3,.box .item2 p,.box .item2 .el-button{
  margin-top: 2em;
  margin-left: 2em;
}
.box .item2 p{
  width: 80%;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}
.box .item2 .el-button{
  color:white;
  width: 8em;
  height: 2.5em;
  background-color: transparent;
}
.data_split{
  margin-top: 6em;
  width: 100%;
  height: 15em;
  background-color: #F9FAFC;
}
.split_main{
  overflow: hidden;
  width: 60%;
  margin: 0 auto;
}
.split_main ul{
  display: flex;
  justify-content: space-between;
  width: 100%;
  height: 100%;
  margin-top: 6em;
}
.split_main ul li{
  list-style: none;
}
.split_main ul li img{
  width: 3em;
  height: 3em;
  vertical-align: middle;
}
.split_main ul li span{
  display: inline-block;
  width: auto;
  height: 3.5em;
  margin-left: 0.5em;
  font-size: 1em;
}
.pro_dis{
  width:60%;
  margin: 0 auto;
  margin-top: 8em;
}
.pro_dis h1{
  font-size: 3em;
  margin-bottom: 1em;
}
.pro_dis p{
  margin-bottom: 4em;
}
.el-row{
  width: 100%;
  height: 100%;
}
.el-row .el-col{
  position: relative;
  width: 100%;
  height: 17em;
  margin-bottom: 2em;
}
.el-row .el-col img{
  width: 100%;
  height: 100%;
}
/* .image-container {
  position: relative;
  overflow: hidden;
} */

.fade-enter-active, .fade-leave-active {
  transition: opacity 0.1s ease;
}
.fade-enter-from, .fade-leave-to {
  opacity: 0;
}
.uniform-height {
  width: 100%;
  height: 20em;
}

.full-size-image {
  width: 100%;
  height: 100%;
}

.image-container {
  /* display: flex;
  align-items: flex-end; */
  position: relative;
  overflow: hidden;
  width: 100%;
  height: 100%;
  background-position: center;
  background-size: 100% 100%;
  background-repeat: no-repeat;
}
.col-box {
  color: white;
  position: absolute;
  bottom: 0;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  line-height: 1.8em;;
  height: 6em;
  width: 100%;
  margin: 0 auto;
  background-color: rgba(0,0,0,0.5);
  transition: all 0.1s ease;
}
.col-box >h3{
  font-size:1.1em;
}
.col-box >h3,.col-box >p{
  margin-left: 1em;
}
.col-box >p{
  margin-top: 0.55em;
  font-size: 0.8em;
}
.col-boxx {
  overflow: hidden;
  color: white;
  height: 100%;
  width: 100%;
  background-color: rgba(0,0,0,0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  transition: all 0.1s ease;
  text-align: center;
  cursor: pointer;
}
.col-boxx>p{
  margin-top: 1em;
  font-size: 0.8em;
  width: 80%;
  margin: 0 auto;
}
@media (max-width: 1024px)  {
  .banner{
    height: 11em;
    background-image: url('https://official-web-static.womucloud.com/bigBanner/m/product.jpg');
    margin-bottom: 1em;
    text-align: center;
  }
  .banner h1{
    font-size: 1.2em;
  }
  .inner-le,.inner-ri{
    font-size: 0.8em;
    height: 2.5em;
  }
.data_main{
  position: relative;
  width: 100%;
  margin: 0 auto;
}
.box{
  width: 100%;
  height: 10em;
  margin-bottom: 0.5em;
}
.box .item1{
  color:white;
  width: 39%;
  height: 100%;
  background-color: #ddd;
}
.box .item1 img{
  width: 100%;
  height: 100%;
}
.box .item2{
  color:white;
  width: 59%;
  height: 100%;
}
.box .item2 h3,.box .item2 p,.box .item2 .el-button{
  margin-top: 1em;
  margin-left: 1.5em;
}
.box .item2 h3{
  font-size: 0.9em;
  font-weight: 400;
}
.box .item2 p{
  font-size: 0.8em;
  width: 80%;
}
.box .item2 .el-button{
  color:white;
  width: 4em;
  height: 1.5em;
  font-size: 0.8em;
  background-color: transparent;
}
.data_split{
  display: flex;
  align-items: center;
  margin-top: 1em;
  width: 100%;
  height: 3em;
  background-color: #F9FAFC;
}
.split_main{
  overflow: hidden;
  width: 95%;
  margin: 0 auto;
  font-size: 0.5em;
}
.split_main ul{
  display: flex;
  justify-content: space-between;
  width: 100%;
  height: 100%;
  margin-top: 0em;
}
.split_main ul li{
  list-style: none;
}
.split_main ul li img{
  width: 1em;
  height: 1em;
  vertical-align: middle;
}
.split_main ul li span{
  display: inline-block;
  width: auto;
  height: 0.5em;
  margin-left: 0.1em;
  font-size: 1em !important;
}
.pro_dis{
  width:95%;
  text-align: center;
  margin: 0 auto;
}
.data_h h1{
  font-size: 1.5em;
  margin-top: 0.5em;
  margin-bottom: 0.5em;
  text-align: center;
  width: 100%;
}
.pro_dis h1{
  font-size: 1.5em;
  margin-bottom: 0.5em;
  text-align: center;
}
.pro_dis p{
  font-size: 0.8em;
  margin-bottom: 1em;
}
.el-row{
  width: 100%;
  height: 100%;
  margin: 0 auto !important;
}
.el-row .el-col{
  width: 100%;
  height: 15em;
  margin-bottom: 2em;
}

.uniform-height {
  width: 100%;
  height: 15em;
}

.full-size-image {
  width: 100%;
  height: 100%;
}
/* .col-box{
  margin-top: 97%;
} */
.col-box >h3{
  font-size:0.8em;
}
.col-box >h3,.col-box >p{
  margin-left: 0.5em;
}
.col-box >p{
  margin-top: 0.55em;
  font-size: 0.5em;
}
}
.data_pl_video {
  width: 60%;
  margin: 0 20%;
  height: 30em;
}
.data_pl_video_m {
  width: 80%;
  margin: 0 10%;
  height: 15em;
}
</style>
